import clsx from 'clsx';
import { Children, cloneElement, isValidElement, ReactElement, ReactNode } from 'react';

import styles from '../Editor.module.css';

export type ButtonGroupProps = {
  label?: string;
  preIcon?: string | ReactNode;
  children: ReactNode;
  vertical?: boolean;
  small?: boolean;
};

interface ChildProps {
  size?: string;
}

export const ButtonGroup = ({ children, preIcon, label, vertical = false, small = false }: ButtonGroupProps) => {
  const childrenWithProps = Children.map(children, child => {
    if (isValidElement(child)) {
      const typedChild = child as ReactElement<ChildProps>;
      return cloneElement(child, { size: small ? 'small' : typedChild.props.size || undefined } as ChildProps);
    }
    return child;
  });

  return (
    <div className={clsx(styles.buttonGroup, vertical && styles.buttonGroupVertical, small && styles.small)}>
      {(!!preIcon || !!label) && (
        <div className={styles.buttonGroupInner}>
          {!!preIcon &&
            (typeof preIcon === 'string' ? (
              <div className={styles.buttonGroupPreIcon}>
                <i className={`c-icon-custom c-icon-custom--vertical-centered c-icon-custom--${preIcon}`} />
              </div>
            ) : (
              <div className={styles.buttonGroupPreIconComponent}>{preIcon}</div>
            ))}
          {!!label && <div className={styles.buttonGroupLabel}>{label}</div>}
        </div>
      )}
      <div className={styles.buttonGroupButtons}>{childrenWithProps}</div>
    </div>
  );
};
